import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('ents-wishlist-newsletter-teaser')
export class EntWishlistNewsletterTeaser extends LitElement {

  @property({type: Boolean})
  private inlist: boolean = false;

  @property({type: Boolean, reflect: true})
  hidden: boolean = false;

  private readonly initialHiddenState: boolean = false;

  static styles = css`
    :host {
      display: block;
    }
  `;

  constructor() {
    super();

    this.initialHiddenState = this.getAttribute('hidden') !== null;
    this.onTabChange = this.onTabChange.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener('ents:wishlist:tab:changed', this.onTabChange);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener('ents:wishlist:tab:changed', this.onTabChange);
  }

  private onTabChange({detail: {tab}}: CustomEvent<{ tab: 'favorites' | 'collections' }>) {
    if (tab === 'favorites') {
      this.hidden = this.initialHiddenState;
    } else {
      // for collections inlist is always hidden and bottom teaser is always visible
      this.hidden = this.inlist;
    }
  }

  render() {
    return html`
      <slot></slot>`;
  }
}
